export const GRACE_PERIOD_MS = 5 * 24 * 60 * 60 * 1000; // 5 days in ms

/** Returns the period end as a timestamp in ms, or null if not set. */
export const getEndMs = (sub: { current_period_end?: string | null } | null) =>
  sub?.current_period_end ? new Date(sub.current_period_end).getTime() : null;

/** Returns the grace period end as a timestamp in ms (period end + 5 days). */
export const getGraceEndMs = (
  sub: { current_period_end?: string | null } | null,
) => {
  const e = getEndMs(sub);
  return e ? e + GRACE_PERIOD_MS : null;
};

/** True if the current time is past current_period_end. */
export const isExpired = (sub: any, nowMs = Date.now()): boolean => {
  const e = getEndMs(sub);
  return e ? nowMs > e : false;
};

/** True if past period end but still within the 5-day grace window. */
export const isInGracePeriod = (sub: any, nowMs = Date.now()): boolean => {
  const e = getEndMs(sub);
  const g = getGraceEndMs(sub);
  return e && g ? nowMs > e && nowMs <= g : false;
};

/** True if the grace period window has also elapsed. */
export const isPastGrace = (sub: any, nowMs = Date.now()): boolean => {
  const g = getGraceEndMs(sub);
  return g ? nowMs > g : false;
};

/** Number of full days remaining in the grace period (minimum 1 when >0). */
export const graceDaysRemaining = (sub: any, nowMs = Date.now()): number => {
  const g = getGraceEndMs(sub);
  if (!g) return 0;
  const diff = g - nowMs;
  return diff <= 0 ? 0 : Math.max(1, Math.ceil(diff / 86400000));
};
